<template>
  <el-dialog width="550px" :visible.sync="visible" :title="!dataForm.id ? $t('add')+'员工用户' : $t('update')+'员工用户'" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" style="padding-right: 50px;" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
    
      <el-form-item prop="caName" label="企业名称">
        <el-input v-model="dataForm.caName" placeholder="企业名称" disabled></el-input>
      </el-form-item>
      <!-- <el-form-item prop="simpleName" label="企业简称">
        <el-input v-model="dataForm.simpleName" placeholder="企业简称" disabled></el-input>
      </el-form-item> -->
      <el-form-item prop="realName" label="姓名">
          <el-input v-model="dataForm.realName" placeholder="姓名" :disabled="dataForm.id ? true : false"></el-input>
      </el-form-item>
      <el-form-item prop="mobile" label="手机号">
          <el-input v-model="dataForm.mobile" placeholder="手机号" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item prop="password" :label="$t('user.password')">
        <el-input v-model="dataForm.password" type="password" :placeholder="$t('user.password')" class="ipt" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="dataForm.deactivate" true-label="yes" false-label="no">停用</el-checkbox>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()" :loading="loadingbut">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { isEmail, isMobile,testPassword } from '@/utils/validate'
import aesJs from '../../../utils/login-aes'
export default {
  data () {
    return {
      visible: false,
      roleList: [],
      roleIdListDefault: [],
	  loadingbut: false,
      dataForm: {
        id: '',
        caName: '',
        caId:'',
        realName:'',
        simpleName: '',
        password: '',
        deactivate: 'no',
        mobile: ''
      }
    }
  },
  computed: {
    dataRule () {
        var validateName = (rule, value, callback) => {
           if(!value){
               callback('必填项不能为空')
           }
            // else if(value.indexOf('（') > -1 || value.indexOf('）') > -1 ){
            //     callback(new Error("检测出符号错误'（'与'）'必须是英文符号格式！"))
            // }
            callback()
        }
      var validateMobile = (rule, value, callback) => {
		    if (!isMobile(value)) {
		        return callback(new Error(this.$t('validate.format', { 'attr': this.$t('user.mobile') })))
		    }
		    callback()
      }
      var checkpassword = (rule, value, callback) => {
          //根据 this.dataForm.id判断
          if(!!this.dataForm.id){
             //  修改
            if(!!value){
              if(!testPassword(value)){
                callback(new Error('请设置8到12位数字，大写、小写字母，符号，至少三种'))
              }
              callback()
            }
            callback()
          }else{
            //  新增
            if(testPassword(value)){
              callback()
            }else{
              callback(new Error('请设置8到12位数字，大写、小写字母，符号，至少三种'))
            }
          }
      }
      return {
		    realName: [{ required: true, validator:validateName, trigger: 'blur' }],
        mobile: [
          { required: true, message: '输入正确的电话号码', validator: validateMobile, trigger: 'blur' }
        ],
		    // simpleName: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        password: [
          { required: true,validator: checkpassword,trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/user/getInfoById?id=${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.dataForm.deactivate = (res.data.status == 0 ? 'yes' : 'no')
        console.log(this.dataForm.deactivate)
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
//        名称中的中文括号替换成英文括号
        this.dataForm.caName = this.dataForm.caName.replace('（','(');
        this.dataForm.caName = this.dataForm.caName.replace('）',')');
        this.dataForm.simpleName = this.dataForm.simpleName.replace('（','(');
        this.dataForm.simpleName = this.dataForm.simpleName.replace('）',')');
        let url = '/sys/plat/info/ca/create'
        if (this.dataForm.id > 0) {
          url = '/sys/plat/info/ca/update'
          this.dataForm.userId = this.dataForm.id
        }
        this.loadingbut = true
        let paramsForm = JSON.parse(JSON.stringify(this.dataForm));
        paramsForm.password = aesJs.encrypt(paramsForm.password)
        this.$http.post(url, {
          ...paramsForm
        }).then(({ data: res }) => {
          // this.dataForm.password = aesJs.decrypt(this.dataForm.password)
          this.loadingbut = false
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style lang="scss" scoped>
.mod-sys__user {
  .dept-list {
    .el-input__inner,
    .el-input__suffix {
      cursor: pointer;
    }
  }
  .role-list {
    .el-select {
      width: 100%;
    }
  }
}
.ipt {
  /deep/ .el-input__inner {
    -webkit-text-security:disc!important;
  } 
}
</style>
